// onboarding-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'onb.ui.alreadyLinked': 'Dette foretaket er allerede koblet til brukeren din. Velg det i klientvelgeren i stedet for å opprette det på nytt.',
  'onb.ui.personalNotConnected': 'Privatøkonomi er ikke koblet til backend i denne builden.',
  'onb.ui.personalCreatedLinked': 'Privatøkonomi er opprettet og familien er koblet sammen.',
  'onb.ui.personalCreatedInvitePending': 'Privatøkonomi er opprettet, men invitasjonen må godtas fra varselet.',
  'onb.ui.personalCreated': 'Privatøkonomi er opprettet',
  'onb.ui.personalCreateFailed': 'Kunne ikke opprette privatøkonomi.',
  'onb.ui.orgNumberNineDigits': 'Organisasjonsnummer må være 9 siffer.',
  'onb.ui.alreadyExists': 'Dette foretaket finnes allerede i Plumme.',
  'onb.ui.createNotConnected': 'Opprett foretak er ikke koblet til backend.',
  'onb.ui.companyCreated': 'Foretaket er opprettet',
  'onb.ui.companyCreateFailed': 'Kunne ikke opprette foretak.',
  'onb.ui.chooseSubPersonal': 'Personlig oversikt, familieøkonomi, mål og skatt – uten krav om foretak.',
  'onb.ui.chooseSubFirm': 'Opprett regnskapsbyrå, godta klientoppdrag, eller start et nytt klientforetak.',
  'onb.ui.leadVerify': 'Plumme verifiserer norske organisasjonsnummer mot Brønnøysundregistrene og oppretter tilgang.',
  'onb.ui.step1Company': 'Steg 1 · Foretaket',
  'onb.ui.back': '← Tilbake',
  'onb.ui.creating': 'Oppretter...',
  'onb.ui.createAndAccept': 'Opprett og godta',
  'onb.ui.createPersonal': 'Opprett Privatøkonomi',
  'onb.ui.createCompany': 'Opprett foretak',
  'onb.ui.getStarted': 'Kom i gang',
  'onb.ui.next': 'Neste',
});
